import { API } from '../../config';
import M2Request from '../../library/M2Request';

const Endpoints = {
    "auth": "token",
    "self": "users/self",
    "update": "users/self",
    "device": "users/devices",
    "feedback": "users/support"
};


export function sendFeedback(data) {
    return M2Request(Endpoints.feedback, "POST", data);
}


export function addDevice(device_id) {
    return M2Request(Endpoints.device, "POST", {device_id: device_id});
}


export function getProfile() {
    return M2Request(Endpoints.self, "GET");
}

export function updateProfile(data) {
    return M2Request(Endpoints.update, "PUT", data);
}


export function authUser(login, password) {
    let data = {
        'username': login,
        'password': password,
        'grant_type': 'password',
        'client_id': login,
        'client_secret': password
    };

    return M2Request(Endpoints.auth, "POST", data, {});
};


// WEBPACK FOOTER //
// ./src/models/user/api.js